// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Searchbar.module.css */
.Search_searchBar__Ho1d9 {
    display: flex;
    align-items: center;
    margin-left: 0px;
    margin-top: 12px;
    /* margin-bottom: 3px; */
    background-color: #FFFFFF; /* Light background color */
    border: 1px solid lightgrey; 
    border-radius: 8px;
    width: 300px; 
    height: 40px;/* Set width as needed */
    margin-left: 20px;
   /* Adjust max-width */
  }
  
  .Search_searchIcon__nPexd {
    width: 14px; 
    height: 14px; 
    margin-left: 5px;
  }
  
  .Search_searchInput__KLnWb {
    font-family: roboto;
    border: none;
    margin-left: 4px;
    height: 14px;
    background: none;
    width: 100%;
    font-size: 14px;
    line-height: 16px;
  }
  
  .Search_searchInput__KLnWb:focus {
    border: none; /* Ensure border is not shown when focused */
    outline: none; /* Remove the outline */
}
  `, "",{"version":3,"sources":["webpack://./src/Pages/BuzzCom/components/FriendComponents/Search.module.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB,EAAE,2BAA2B;IACtD,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;IACZ,YAAY,CAAC,wBAAwB;IACrC,iBAAiB;GAClB,qBAAqB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY,EAAE,4CAA4C;IAC1D,aAAa,EAAE,uBAAuB;AAC1C","sourcesContent":["/* Searchbar.module.css */\n.searchBar {\n    display: flex;\n    align-items: center;\n    margin-left: 0px;\n    margin-top: 12px;\n    /* margin-bottom: 3px; */\n    background-color: #FFFFFF; /* Light background color */\n    border: 1px solid lightgrey; \n    border-radius: 8px;\n    width: 300px; \n    height: 40px;/* Set width as needed */\n    margin-left: 20px;\n   /* Adjust max-width */\n  }\n  \n  .searchIcon {\n    width: 14px; \n    height: 14px; \n    margin-left: 5px;\n  }\n  \n  .searchInput {\n    font-family: roboto;\n    border: none;\n    margin-left: 4px;\n    height: 14px;\n    background: none;\n    width: 100%;\n    font-size: 14px;\n    line-height: 16px;\n  }\n  \n  .searchInput:focus {\n    border: none; /* Ensure border is not shown when focused */\n    outline: none; /* Remove the outline */\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchBar": `Search_searchBar__Ho1d9`,
	"searchIcon": `Search_searchIcon__nPexd`,
	"searchInput": `Search_searchInput__KLnWb`
};
export default ___CSS_LOADER_EXPORT___;
